/**
 * Composables/utils/useTimeout.ts without Vue: one timer per instance, launchTimeout() cancels
 * the previous one, nothing is cleared when the owner goes away (as the composable).
 */
export interface TimeoutHandle {
    launchTimeout: (delay: number, callback: () => void) => void;
    cancelTimeout: () => void;
}

export function useTimeout(): TimeoutHandle {
    let timeout: number | null = null;

    const cancelTimeout = (): void => {
        if (timeout) {
            window.clearTimeout(timeout);
            timeout = null;
        }
    };

    const launchTimeout = (delay: number, callback: () => void): void => {
        cancelTimeout();
        timeout = window.setTimeout(callback, delay);
    };

    return { launchTimeout, cancelTimeout };
}
